import React from 'react';
const AnchorLink = ({ link, children }) => {
    return (React.createElement("a", { href: link, className: "text-xl leading-6 font-normal text-blue-700 hover:text-blue-600 underline" }, children));
};
const PageHeader = ({ shortTitle, title, hasLink, link, childLink, childTitle }) => {
    return (React.createElement("section", { className: "py-24 bg-white" },
        React.createElement("div", { className: "w-full flex flex-col md:items-center items-start md:text-center gap-6 sm:max-w-4xl mx-auto px-6" },
            shortTitle &&
                (hasLink && link ? (childLink && childTitle ? (React.createElement("div", { className: "flex items-center gap-2 md:justify-center" },
                    React.createElement(AnchorLink, { link: link }, shortTitle),
                    React.createElement("span", { className: "text-gray-800 text-xl leading-6 font-normal" }, ">"),
                    React.createElement(AnchorLink, { link: childLink }, childTitle))) : (React.createElement(AnchorLink, { link: link }, shortTitle))) : (React.createElement("h5", { className: "text-xl leading-6 font-normal text-blue-700" }, shortTitle))),
            React.createElement("h1", { className: "text-gray-800 md:text-5xl text-3xl md:leading-[120%] leading-9 font-semibold" }, title))));
};
export default PageHeader;
